import { render, staticRenderFns } from "./attaUpload.vue?vue&type=template&id=3daa3891&"
import script from "./attaUpload.vue?vue&type=script&lang=js&"
export * from "./attaUpload.vue?vue&type=script&lang=js&"
import style0 from "./attaUpload.vue?vue&type=style&index=0&id=3daa3891&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports